import { axios } from '@/utils/request'
const api = {
  source: '/finance/customerBill',
  remark:'/finance/billRemark',
 create:'/finance/customerStatement',
  confirm:'/finance/receiptHistory'
}
// 获取列表数据
export function getSourceList (parameter) {
  return axios({
    url: api.source + '/list',
    method: 'get',
    params: parameter
  })
}
export function getexportList (parameter) {
  return axios({
    url: '/finance/customerBill/export',
    method: 'get',
    params: parameter,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  })
}
export function getconfirmcustomer (parameter) {
  return axios({
    url: api.create + '/confirm',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 获取备注信息
export function getremarkList (parameter) {
  return axios({
    url: api.remark + '/list',
    method: 'get',
    params: parameter
  })
}
// 客户自费生成对账单
export function getEnterpriseList (parameter) {
  return axios({
    url: api.create + '/create',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/*查询账单需付款  确认收款*/
export function getConfirmList (parameter) {
  return axios({
    url: api.confirm + '/needPay',
    method: 'get',
    params: parameter
  })
}
/*查询账单需付款  确认收款*/
export function getalreadyPay (parameter) {
  return axios({
    url: api.confirm + '/alreadyPay',
    method: 'get',
    params: parameter
  })
}
/*账单付款*/
export function payreceiptHistory (parameter) {
  return axios({
    url: api.confirm + '/pay',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/*账单退款*/
export function refundreceiptHistory (parameter) {
  return axios({
    url: api.confirm + '/refund',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
